module.exports = __webpack_public_path__ + "img/flash-sale-logo.932a42e3.png";